import React, { useState } from 'react';
import './trusted-partner.scss';

const tabs = ['Airlines', 'Lounge Access', 'eSim', 'Hotels'];

const partnerLogos = {
    Airlines: [
        '/images/airlines/logo1.svg',
        '/images/airlines/logo2.svg',
        '/images/airlines/logo3.svg',
        '/images/airlines/logo4.svg',
        '/images/airlines/logo5.svg',
        '/images/airlines/logo6.svg',
        '/images/airlines/logo7.svg',
        '/images/airlines/logo8.svg',
        '/images/airlines/logo9.svg',
        '/images/airlines/logo10.svg',
        '/images/airlines/logo11.svg',
    ],
    'Lounge Access': [
        '/images/airlines/logo2.svg',
        '/images/airlines/logo3.svg',
        '/images/airlines/logo4.svg',
        '/images/airlines/logo5.svg',
        '/images/airlines/logo6.svg',
        '/images/airlines/logo7.svg',
    ],
    eSim: [
        '/images/airlines/logo2.svg',
        '/images/airlines/logo6.svg',
        '/images/airlines/logo5.svg',
        '/images/airlines/logo7.svg',
    ],
    Hotels: [
        '/images/airlines/logo7.svg',
        '/images/airlines/logo8.svg',
        '/images/airlines/logo9.svg',
        '/images/airlines/logo10.svg',
        '/images/airlines/logo11.svg',
    ],
};

const TrustedPartner = () => {
    const [activeTab, setActiveTab] = useState('Airlines');

    return (
        <section className="trusted-partner-section">
            <div className="container">
                <div className="heading">
                    <h2>Our Trusted Partners</h2>
                </div>

                {/* Tab Navigation */}
                <ul className="nav nav-tabs partner-tabs">
                    {tabs.map((tab) => (
                        <li className="nav-item" key={tab}>
                            <button
                                className={`nav-link ${activeTab === tab ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </button>
                        </li>
                    ))}
                </ul>

                {/* Tab Content */}
                {partnerLogos[activeTab].length > 0 ? (
                    <div className="logo-grid">
                        {partnerLogos[activeTab].map((src, index) => (
                            <div key={index} className="logo-card">
                                <img src={src} alt={`logo-${index}`} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-muted">No partners listed for this category.</p>
                )}


            </div>
        </section>
    );
};

export default TrustedPartner;
